export default __webpack_public_path__ + "postMock-1751905504885.html";